import { Component, Input } from '@angular/core';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';
import { EntityCredentialApplication } from 'src/app/shared/models/credential/entityCredentialApplication';

@Component({
  selector: 'credential-application-card',
  templateUrl: './credential-application-card.component.html',
  styleUrls: ['./credential-application-card.component.scss'],
  standalone: false
})
export class CredentialApplicationCardComponent {
  @Input() application: EntityCredentialApplication;
  public CredentialStatusLabelColor = CredentialStatusLabelColor;
}
